import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { GalleryImage } from '../data/types';
interface LightboxProps {
  images: GalleryImage[];
  currentIndex: number;
  isOpen: boolean;
  onClose: () => void;
  onNext: () => void;
  onPrev: () => void;
}
export const Lightbox: React.FC<LightboxProps> = ({
  images,
  currentIndex,
  isOpen,
  onClose,
  onNext,
  onPrev
}) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!isOpen) return;
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onNext();
      if (e.key === 'ArrowLeft') onPrev();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose, onNext, onPrev]);
  if (!isOpen || images.length === 0) return null;
  const currentImage = images[currentIndex];
  return <AnimatePresence data-id="element-124" data-mp="27updlwhw7hxu">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4" onClick={onClose} data-id="element-125" data-mp="241b35wenmiur">
        <button onClick={e => {
        e.stopPropagation();
        onClose();
      }} className="absolute top-4 right-4 text-white hover:text-primary transition-colors p-2" data-id="element-126" data-mp="1qa6877m8eeqr">
          <X size={32} data-id="element-127" data-mp="2i0u7sf89bc2b" />
        </button>

        <button onClick={e => {
        e.stopPropagation();
        onPrev();
      }} className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:text-primary transition-colors p-2" data-id="element-128" data-mp="2i25d4jhcorvj">
          <ChevronLeft size={48} data-id="element-129" data-mp="12klnaj6ip7eu" />
        </button>

        <motion.div key={currentIndex} initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9
      }} transition={{
        duration: 0.2
      }} className="relative max-w-5xl max-h-[90vh] w-full flex flex-col items-center" onClick={e => e.stopPropagation()} data-id="element-130" data-mp="12m6mim3s1ej1">
          {currentImage.url.startsWith('http') || currentImage.url.startsWith('data:') ? <img src={currentImage.url} alt={currentImage.caption || 'Gallery image'} className="max-w-full max-h-[80vh] object-contain rounded-lg" data-id="element-131" data-mp="galrjxf6v1u2" /> : <div className="w-full aspect-video max-h-[80vh] bg-primary rounded-lg flex items-center justify-center text-9xl shadow-2xl" data-id="element-132" data-mp="6bxlzy4e4f79">
              {currentImage.url}
            </div>}

          {currentImage.caption && <p className="text-white mt-4 text-lg font-medium text-center" data-id="element-133" data-mp="2cx72qp19wpj">
              {currentImage.caption}
            </p>}
        </motion.div>

        <button onClick={e => {
        e.stopPropagation();
        onNext();
      }} className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-primary transition-colors p-2" data-id="element-134" data-mp="3exugox09se7e">
          <ChevronRight size={48} data-id="element-135" data-mp="3juksh851knn0" />
        </button>
      </motion.div>
    </AnimatePresence>;
};